function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_31544_2356)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8949 11.2572C17.6465 10.3249 16.7435 9.49539 15.307 8.8945C13.8322 8.27759 11.9016 7.93777 9.87045 7.93777C7.81342 7.93777 6.07056 8.22418 4.67972 8.78967C4.19525 8.19946 3.46039 7.82211 2.63901 7.82211C2.09534 7.82211 1.58951 7.98752 1.16913 8.27057V5.01328H0V18.92H1.16913V17.4704H18.7845V18.92H19.9538V13.3176H19.2412C19.1617 12.4298 18.6383 11.6682 17.8949 11.2572ZM9.87045 9.1069C11.7502 9.1069 13.5208 9.41452 14.8558 9.97314C15.5215 10.2516 16.0434 10.5844 16.3776 10.9312H5.2359C5.26382 10.7768 5.27817 10.6197 5.27817 10.4613C5.27817 10.2469 5.25192 10.0388 5.20355 9.83917C6.43936 9.35318 8.00583 9.1069 9.87045 9.1069ZM2.63916 8.99139C3.44971 8.99139 4.10904 9.65073 4.10904 10.4613C4.10904 10.6221 4.08249 10.7808 4.03183 10.9312H1.24649C1.19583 10.7808 1.16913 10.6221 1.16913 10.4613C1.16913 9.65073 1.82861 8.99139 2.63916 8.99139ZM1.16913 12.1004H16.6307C17.3515 12.1004 17.9509 12.6282 18.0637 13.3174H1.16913V12.1004ZM1.16913 14.4867H18.7845V16.3013H1.16913V14.4867Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1595 4.54742V3.3783H12.5053L14.5565 1.05469H10.2885V2.22382H11.9648L9.91357 4.54742H14.1595Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6028 7.11395V5.94482H17.9486L19.9999 3.62106H15.7318V4.79034H17.4082L15.3569 7.11395H19.6028Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_31544_2356"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgSleep = function SvgSleep(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSleep, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sleep.1b09a8d0.svg";
export { ForwardRef as ReactComponent };